import { render } from "./MarketingCampaignFlowOverview.vue?vue&type=template&id=5047a92e&scoped=true"
import script from "./MarketingCampaignFlowOverview.vue?vue&type=script&lang=js"
export * from "./MarketingCampaignFlowOverview.vue?vue&type=script&lang=js"

import "./MarketingCampaignFlowOverview.vue?vue&type=style&index=0&id=5047a92e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5047a92e"]])

export default __exports__